module.exports = __webpack_public_path__ + "img/itx-file-type-ogg.ef4b6847.svg";